<app-main-page>
  <app-products-list></app-products-list>
</app-main-page>
